<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="100px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="5">
              <el-form-item label="类别" prop="payType">
                <el-select v-model="queryParams.payType" placeholder="请选择类别" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="返点费用" value="1" />
                  <el-option label="配合费用" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称"  @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="使用单位" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="检测时间" prop="testDateRange">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="付款状态" prop="payStatus">
                <el-select v-model="queryParams.payStatus" placeholder="请选择付款状态" style="width: 100%;" @change="handleQuery">
                  <el-option label="未付款" value="2" />
                  <el-option label="已付款" value="1" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24" type="flex" justify="right"></el-row> -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @handleCancel="handleCancelPayment" @handlePayment="handlePayment" />
          </div>
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    @selection-change="handleSelectionChange" height="500">
            <el-table-column type="selection" width="55" align="left"></el-table-column>
            <el-table-column label="识别码" align="left" prop="OIDNO" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 委托编号列 -->
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="配合费" align="left" prop="cooperationFee" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="返点费用" align="left" prop="rebateFee" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="配合费付款备注" align="left" prop="cooperationRemark" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="返点付款备注" align="left" prop="rebateRemark" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="标准价" align="left" prop="testCharge" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="折扣" align="left" prop="custDiscount" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="折后价" align="left" prop="finalPrice" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测时间" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测员" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="付款状态" align="left" prop="payStatus" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.payStatus == '1'? '已付款': '未付款'}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" align="left" width="100" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)"  @handlePayment="handlePayment(scope.row)" />
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.currPage"
            :page-sizes="[10, 20, 50, 100,200,500]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>
    <PaymentDialog ref="paymentDialog" @refresh="getList" />
  </div>
</template>

<script>
import { queryPaymentList, cancelPayment } from '@/api/contract/contract'
import PaymentDialog from './PaymentDialog.vue'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'

export default {
  name: 'PaymentManagement',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PaymentDialog,
    PermissionMethodToolbar
  },
  data () {
    return {
      showSearch: true,
      tableData: [],
      loading: true,
      total: 0,
      queryParams: {
        currPage: 1,
        pageSize: 200,
        payType: '1',
        compNames: '',
        usingUnit: '',
        testDateRange: [],
        payStatus: '2'
      },
      selectedRows: []
    };
  },
  created () {
    this.getList()
  },
  methods: {
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.getList()
    },
    getList () {
      this.loading = true
      const params = {
        ...this.queryParams,
        testDateStart: this.queryParams.testDateRange && this.queryParams.testDateRange.length > 0 ? this.queryParams.testDateRange[0] : '',
        testDateEnd: this.queryParams.testDateRange && this.queryParams.testDateRange.length > 1 ? this.queryParams.testDateRange[1] : ''
      }
      queryPaymentList(params).then(res => {
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records
          this.total = res.additionalData.total
          this.queryParams.currPage = res.additionalData.current
          this.queryParams.pageSize = res.additionalData.size
          this.loading = false
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.loading = false
      })
    },
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    handlePayment () {
      // 检查是否有勾选数据
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }

      // 检查是否有已付款的数据
      const hasPaid = this.selectedRows.some(row => row.payStatus === '1')
      if (hasPaid) {
        this.$message.warning('已付款的不能重复付款，请重新选择')
        return
      }

      // 检查是否选择了付款类别
      if (!this.queryParams.payType) {
        this.$message.warning('请先选择付款类别（返点费用/配合费用）')
        return
      }

      // 传递勾选的数据和付款类型到付款弹窗
      this.$refs.paymentDialog.openDialog(this.selectedRows, this.queryParams.payType)
    },
    handleCancelPayment () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      this.$confirm('确定要撤销选中的付款记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const cancelData = {
          paySerialNo: this.selectedRows.map(row => row.paySerialNo)
        }
        cancelPayment(cancelData).then(res => {
          if (res.retCode === 'ok') {
            this.$message.success('撤销成功')
            this.getList()
          } else {
            this.$message.error(res.retMsg || '撤销失败')
          }
        }).catch(error => {
          console.error('撤销失败:', error)
          this.$message.error('撤销失败')
        })
      }).catch(() => {
        this.$message.info('已取消撤销')
      })
    },
    /**
 * 获取禁用的按钮列表
 * @param {Object} row - 当前行数据
 * @returns {Array} 禁用的按钮名称数组
 */
    getDisabledButtons (row) {
      if (row.payStatus == '1') {
        return ['handlePayment']
      }
      return []
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
